import React, { forwardRef } from 'react'
import { useContext, useCallback } from 'sb-hooks'

import { AccordionItemContext } from './AccordionItem'


type AccordionButtonProps = React.HTMLAttributes<HTMLButtonElement> & {
  dataTestId?: string
}

const AccordionButton = forwardRef<HTMLButtonElement, AccordionButtonProps>((props, ref) => {
  const { dataTestId, onClick, onKeyDown, ...rest } = props

  const { state, setOpen } = useContext(AccordionItemContext)

  const handleClick = useCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    if (state.isOpen) {
      setOpen(false)
    }
    else {
      setOpen(true)
    }
  }, [ onClick, setOpen, state.isOpen ])

  const handleKeyDown = useCallback((event) => {
    if (typeof onKeyDown === 'function') {
      onKeyDown(event)
    }

    if (event.key === 'Space' || event.key === 'Enter') {
      event.preventDefault() // prevent scroll
      setOpen(true)
    }
  }, [ onKeyDown, setOpen ])

  return (
    <button
      id={state.buttonId}
      aria-controls={state.panelId}
      aria-expanded={state.isOpen}
      type="button"
      ref={ref}
      data-testid={dataTestId}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      {...rest}
    />
  )
})


export default AccordionButton
